import { useContext } from "react";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { useAppMessage, useDaily } from "@daily-co/daily-react";
import {
  CustomAppEvent,
  CustomAppEvents,
} from "modules/audioVideo/DailyEvents";
import { useDevices } from "modules/audioVideo/hooks";

interface IJoinStage {
  withMic: boolean;
  withCam: boolean;
}

const useJoinStage = () => {
  const { track } = useContext(TRACKING_CONTEXT);

  const sendAppMessage = useAppMessage<CustomAppEvent>();
  const daily = useDaily();
  const { setCameraActive, setMicrophoneActive } = useDevices();

  const joinStage = ({ withMic, withCam }: IJoinStage) => {
    track(Events.ADDED_TO_STAGE_STREAMING_ACCEPTED);

    if (daily) {
      Object.values(daily.participants()).forEach((participant) => {
        if (participant.owner) {
          sendAppMessage(
            {
              event: CustomAppEvents.JOIN_STAGE_REQUEST,
              joinStage: true,
              withMic,
              withCam,
            },
            participant.session_id,
          );
        }
      });
    }

    setCameraActive(withCam);
    setMicrophoneActive(withMic);
  };

  return { joinStage };
};

export default useJoinStage;
